/* eslint-disable max-len */
import moment from 'moment';
import React, { useContext, useState } from 'react';
import UpdateButton from '../../../../components/UpdateButton';
import AnimatedModel from '../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../components/Context/GloablContext';
import { dataService } from '../../../../services/data.services';
import { useNavigate, useParams } from 'react-router-dom';
import AnimatedButton from '../../../../components/Animation/AnimatedButton';
import { FormattedNumber } from '../../../../CommonMethods/FormattedNumber';
import AnimatedList from '../../../../components/Animation/AnimatedList';
import FormatDateString from '../../../../CommonMethods/FromatDateString';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';

const TableBody = ({tableData, indexNum, pageNumber, branchName, selectedIndex,email, setSelectedIndex, selectedRef, getBranch, lastIndex }) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const navigate = useNavigate()
    const urlParams = new URLSearchParams(window.location.search);
    const {setToastErrorMessage, setToastmessage, isInactiveBranch} = useContext(GlobalContext);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [activateOpen, setActivateOpen] = useState(false);
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = { }
            body = {
                "status": !tableData.status,
            }
            let endpoint= `users/${tableData.email_address}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`Employee ${tableData.status ? 'deactivated' : 'activated'} successfully`);
            getBranch()

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }
    const handleConformationClick = () => {
        setActivateOpen(false)
    }
    const handelActionButton = async(indexNum) =>{
        setSelectedIndex(indexNum)

    }
    const onClickActivation = (e) => {
        e.preventDefault();
        setSelectedIndex(null);
        if(e.target.id === 'Edit Employee') {
            navigate(`/employee-master/manage-employee/edit-staff/${tableData.email_address}?${urlParams.toString()}`, {state: {redirect: 'fromListingScreen'}})
        } else if(e.target.id === "View Details") {
            navigate(`/employee-master/manage-employee/view-employee/${tableData.email_address}?${urlParams.toString()}`)
        }
    }

    const handleClickViewClick=()=>{
        navigate(`/employee-master/manage-employee/view-employee/${tableData.email_address}?${urlParams.toString()}`)
    }

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        if(!activateOpen) setSelectedIndex(null)
    });

    return (
        <>
            
            <AnimatedList
                cursorpointer
                handleClick={(e)=>{
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        handleClickViewClick()
                    }
                }}
                keyItem={indexNum}
                rowStatus={tableData.status}
                title={'View Details'}
                child={
                
                    <>
                        <td className={`text-start`}>{tableData?.employee_number}</td>
                        <td className={`text-start`}>{tableData?.full_name}</td>
                        <td className={`text-start`}>{tableData.email_address}</td>
                        <td className={`text-start`}>{FormattedNumber(tableData.mobile_number)}</td>
                        <td className={`text-start`}>{tableData?.staff_type}</td>
                        <td className={`text-start`}>{FormatDateString(tableData.created_at)}</td>
                        <td className="px-5 py-3 table-cell">
                            <div className='flex justify-center'>
                                <div className={`w-fit rounded ${tableData.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5`}>
                                    <img loading="lazy" decoding="async" src={tableData.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                    <span className="text-f7 font-normal text-[#031624] pl-1">{tableData.status ? 'Active' : 'Inactive'}</span>
                                </div>
                            </div>
                        </td>
                        <td className="text-center prevent-click">
                            <div className="relative flex items-center justify-center prevent-click" data-te-dropdown-position="dropstart">
                                <button type='button' className="list-more-btn prevent-click" href="#"
                                    id={tableData.email_address}
                                    onClick={() =>handelActionButton(indexNum) }
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" className='prevent-click'/>
                                </button>
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`list-more-optns-div ${(indexNum+1 === 10 || indexNum+2 === 10) ? (tableData.status ? 'top2' : 'top3') : ''} [&[data-te-dropdown-show]]:block`}
                                    aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                    <li title="View Details">
                                        <AnimatedButton 
                                            handleClick={onClickActivation} 
                                            buttonName={"View Details"}
                                            className="list-more-optns prevent-click"                                    />
                                    </li>
                                
                                    {email!==tableData.email_address && !isInactiveBranch && 
                                        <>
                                            {tableData.status && <li title="Edit Employee">
                                                <AnimatedButton 
                                                    handleClick={onClickActivation} 
                                                    buttonName={"Edit Employee"}
                                                    className="list-more-optns prevent-click"                                            />
                                            </li>}
                                            <li title={!tableData.status ? "Activate" : "Deactivate"}>
                                                <AnimatedButton 
                                                    handleClick={()=>setActivateOpen(true)} 
                                                    buttonName={!tableData.status ? "Activate" : "Deactivate"}
                                                    className="list-more-optns prevent-click"
                                                />
                                            </li>
                                        </>
                                    }
                                </ul>}
                            </div>
                        </td>
                    </>
                }
            >         
            </AnimatedList>
            {activateOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${tableData.status ? 'Deactivate' : 'Activate'} Employee`}
                        message = {`Are you sure you want to ${tableData.status ? 'deactivate' : 'activate'} the employee '${tableData.first_name} ${tableData.last_name}' ?`}
                        buttonName = {`${tableData.status ? 'Deactivate' : 'Activate'}`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
        </>
    );
}

export default TableBody;
